import { useAtom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'
import { useCallback } from 'react'

const SEARCH_HISTORY_KEY = 'user:search-history'
const MAX_HISTORY_ITEMS = 5
const searchHistoryAtom = atomWithStorage<string[]>(SEARCH_HISTORY_KEY, [])

export function useSearchHistory() {
  const [history, setHistory] = useAtom(searchHistoryAtom)

  const addToHistory = useCallback(
    (query: string) => {
      const trimmed = query.trim()
      if (!trimmed) return
      setHistory(prev => {
        const filtered = prev.filter(item => item !== trimmed)
        return [trimmed, ...filtered].slice(0, MAX_HISTORY_ITEMS)
      })
    },
    [setHistory],
  )

  const removeFromHistory = useCallback(
    (query: string) => {
      setHistory(prev => prev.filter(item => item !== query))
    },
    [setHistory],
  )

  const clearHistory = useCallback(() => {
    setHistory([])
  }, [setHistory])

  return { history, addToHistory, removeFromHistory, clearHistory }
}

export function clearSearchHistory() {
  localStorage.removeItem(SEARCH_HISTORY_KEY)
}
